/* =====================================================================
   Balleh — search overlay (desktop only)
   Plain type-and-submit search: the overlay <form> GETs /search on Enter.
   No live auto-suggestions — we intentionally do NOT query suggest.json,
   so nothing (neither product results nor a "no results" notice) appears
   under the field while typing. Mobile uses its own inline form in the
   header topbar; the overlay is unreachable ≤768px (pill is hidden).
   ===================================================================== */
(function () {
  'use strict';
  const input = document.querySelector('[data-search-input]');
  const results = document.querySelector('[data-search-results]');
  if (!input || !results) return;

  // Liquid renders a static "popular suggestions" hint for the empty state.
  // Show it only while the field is empty; clear it the moment the user types
  // so the static hint can't be misread as a live result for their query.
  const emptyHint = results.innerHTML;
  input.addEventListener('input', () => {
    results.innerHTML = input.value.trim() === '' ? emptyHint : '';
  });
})();
